<template>
  <div class="blocks-browser card">
    <button
      class="blocks-browser__block"
      type="button"
      :data-block="blockSpecification.id"
      v-for="blockSpecification in specification"
      @click="$emit('add', blockSpecification)"
    >
      <i :class="`fas fa-${blockSpecification.icon}`" aria-hidden="true"></i>
      <span class="text-truncate d-block">{{ blockSpecification.label }}</span>
    </button>
  </div>
</template>

<script>
  export default {
    props: ['specification', 'onAdd'],
  };
</script>
